import { namespace } from 'vuex-class';
import { IEngagementVideoState } from './engagement-video.types';

export const EngagementVideo = namespace('video/engagementVideo');

export const state: IEngagementVideoState = {
  adding: false,
  addedVideo: null,
};

export enum EEngagementVideoAction {
  Add = 'add',
  AddSuccess = 'addSuccess',
  AddFailed = 'addFailed',
  Reset = 'reset',
}

export enum EEngagementVideoMutation {
  SetAdding = 'setAdding',
  SetVideo = 'setVideo',
  SetState = 'setState',
}
